export function shouldShowOperatorDashboard(operatorState, checklist) {
  if (operatorState?.onboarding?.wizardCompleted === true) return true;

  const steps = checklist?.steps || [];
  const modeDone = steps[0]?.complete === true;
  const integrationDone = steps[1]?.complete === true;
  const previewDone = steps[2]?.complete === true;

  return modeDone && integrationDone && previewDone;
}
